import { getAll } from "../db";

export const RELEVANT_PROJECTS = ["relevance", "projects"];

export const relevances = (props) => getAll(RELEVANT_PROJECTS, props);
